// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { useEffect, useMemo, useState } from "react";
import { Stack, useMediaQuery, useTheme } from "@mui/material";
import {
  GridColDef,
  GridActionsCellItem,
  GridPaginationModel,
} from "@mui/x-data-grid";
import { DeleteConfirmModal, Table } from "../../molecules";
import { Loading, StatusBar } from "../../atoms";
import {
  DeleteMerchantRequest,
  IMerchant,
  IVPosRouting,
  useAuthorization,
  useDeleteVPosRouting,
  useGetMerchantStatusList,
  useGetVPosRoutingList,
} from "../../../hooks";
import { useNavigate } from "react-router-dom";
import { useSetSnackBar } from "../../../store/Snackbar.state";
import { PagingResponse } from "../../../hooks/_types";
import { downloadExcel } from "../../../util/downloadExcel";
import { useUserInfo } from "../../../store/User.state";
import { createStatusOperator } from "../../molecules/StatusFilterComponents";
import dayjs from "dayjs";

function RenderStatus(props: GridRenderCellParams<any, string>) {
  const { value } = props;

  return <>{value && <StatusBar status={value} />}</>;
}
export const BankRedirectListingTable = () => {
  const [queryOptions, setQueryOptions] = React.useState({});
  const [tableData, setTableData] = useState<PagingResponse<Array<any>>>();
  const [userInfo] = useUserInfo();
  const theme = useTheme();
  const { showDelete, showUpdate } = useAuthorization();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const navigate = useNavigate();
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 25,
    searchText: null,
  });
  const {
    data: vposRoutingListResponse,
    mutate: getVPosRoutingList,
    isLoading,
  } = useGetVPosRoutingList();

  const editRow = React.useCallback(
    (vPosRouting: IVPosRouting) => () => {
      navigate("/vpos-management/vpos-bankrouting", { state: vPosRouting });
    },
    [navigate]
  );
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(0);
  const setSnackbar = useSetSnackBar();
  const { mutate: vPosRoutingDelete, isLoading: isDeleteLoading } =
    useDeleteVPosRouting();
  const { data: rawMerchantStatus, isLoading: isMerchantStatusLoading } =
    useGetMerchantStatusList({});

  const merchantStatuses = useMemo(() => {
    return rawMerchantStatus?.data?.map(
      (merchantStat: { value: string; key: number }) => {
        return {
          label: merchantStat.key,
          value: `${merchantStat.value}`,
        };
      }
    );
  }, [rawMerchantStatus?.data]);

  const deleteRow = React.useCallback(
    (merchant: IMerchant) => () => {
      setIsDeleteModalOpen(true);
      setSelectedRowId(Number(merchant.id));
    },
    []
  );

  const handleCloseDeleteModal = () => {
    setIsDeleteModalOpen(false);
  };


  useEffect(() => {
    const savedFilter = localStorage.getItem("vposBankListingFilter");
    if (savedFilter) {
      setQueryOptions(JSON.parse(savedFilter));
    }
  }, []);

  useEffect(() => {
    const requestPayload = {
      size: paginationModel.pageSize,
      page: paginationModel.page,
      orderBy: "CreateDate",
      orderByDesc: true,
      merchantId: userInfo ? Number(userInfo?.merchantId) : undefined,
      ...getQueryParams(queryOptions),
    };

    if (queryOptions?.field && queryOptions?.value !== undefined) {
      requestPayload[queryOptions.field] = queryOptions.value;
    }

    getVPosRoutingList(requestPayload, {
      onSuccess: (data) => {
        if (data.isSuccess) {
          setTableData(data?.data);
        } else {
          setSnackbar({
            severity: "error",
            description: data.message,
            isOpen: true,
          });
        }
      },
      onError: () => {
        setSnackbar({
          severity: "error",
          description: "İşlem sırasında bir hata oluştu",
          isOpen: true,
        });
      },
    });
  }, [
    getVPosRoutingList,
    paginationModel.page,
    paginationModel.pageSize,
    setSnackbar,
    queryOptions,
  ]);

  const handleChangePagination = (model: GridPaginationModel) => {
    setPaginationModel(model);
    setTableData(undefined);
    getVPosRoutingList(
      {
        size: paginationModel.pageSize,
        page: paginationModel.page,
        orderBy: "CreateDate",
        orderByDesc: true,
      },
      {
        onSuccess: (data) => {
          if (data.isSuccess) {
            setTableData(data?.data);
          } else {
            setSnackbar({
              severity: "error",
              description: data.message,
              isOpen: true,
            });
          }
        },
        onError: () => {
          setSnackbar({
            severity: "error",
            description: "İşlem sırasında bir hata oluştu",
            isOpen: true,
          });
        },
      }
    );
  };

  const handleDeleteConfirm = () => {
    const deleteRequest: DeleteMerchantRequest = { id: selectedRowId };

    vPosRoutingDelete(deleteRequest, {
      onSuccess: (data: any) => {
        if (data.isSuccess) {
          getVPosRoutingList({
            size: paginationModel.pageSize,
            page: paginationModel.page,
            orderBy: "CreateDate",
            orderByDesc: true,
            searchText: paginationModel.searchText,
          });
          setSnackbar({
            severity: "success",
            isOpen: true,
            description: data.message,
          });
        } else {
          setSnackbar({
            severity: "error",
            description: data.message,
            isOpen: true,
          });
        }
      },
      onError: () => {
        setSnackbar({
          severity: "error",
          description: "İşlem sırasında bir hata oluştu",
          isOpen: true,
        });
      },
    });

    handleCloseDeleteModal();
  };
  const columns: GridColDef[] = useMemo(() => {
    return [
      {
        field: "Aksiyonlar",
        type: "actions",
        width: 80,
        getActions: (params) => {
          return [
            !!showUpdate ? (
              <GridActionsCellItem
                label="Düzenle"
                onClick={editRow(params.row)}
                showInMenu
              />
            ) : (
              <></>
            ),
            !!showDelete ? (
              <GridActionsCellItem
                label="Sil"
                onClick={deleteRow(params.row)}
                showInMenu
              />
            ) : (
              <></>
            ),
          ];
        },
      },
      {
        field: "profileCodes",
        headerName: "Çalışma Grubu",
        width: 200,
      },
      {
        field: "issuerCardBankName",
        headerName: "Yönlendirelecek Kartın Bankası",
        width: 350,
      },
      {
        field: "merchantVposBankName",
        headerName: "Yönlendirelecek Sanal Pos",
        width: 350,
      },
      {
        field: "issuerCardType",
        headerName: "Kart Tipi",
        width: 130,
      },
      {
        field: "transactionSubType",
        headerName: "İşlem Tipi",
        width: 130,
      },
      {
        field: "merchantId",
        headerName: "Üye İşyeri Numarası",
        width: 200,
      },
      {
        field: "merchantName",
        headerName: "Üye İşyeri Adı",
        width: 380,
      },
      {
        renderCell: RenderStatus,
        field: "status",
        headerName: "Statü",
        width: 100,
        filterOperators: [createStatusOperator(merchantStatuses)],
      },
      {
        field: "createDate",
        headerName: "Oluşturma Tarihi",
        width: 200,
        renderCell: (params) => {
          if (!params.value) return "";
          const formattedDate = dayjs(params.value).format("DD.MM.YYYY HH:mm");
          if (formattedDate === "Invalid Date") return "";
          return formattedDate;
        },
      },
      { field: "createUserName", headerName: "Oluşturan Kullanıcı", width: 200 },
      {
        field: "updateDate",
        headerName: "Son Güncellenme Tarihi",
        width: 200,
        renderCell: (params) => {
          if (!params.value) return "";
          const formattedDate = dayjs(params.value).format("DD.MM.YYYY HH:mm");
          if (formattedDate === "Invalid Date") return "";
          return formattedDate;
        },
      },
      { field: "updateUserName", headerName: "Son Güncelleyen Kullanıcı", width: 200 },
    ];
  }, [deleteRow, editRow, showDelete, showUpdate]);
  const keyMapping = {
    status: "Statü",
  };
  const onSave = () => {
    {
      const requestPayload = {
        size: -1,
        page: 0,
        orderBy: "CreateDate",
        orderByDesc: true,
        ...getQueryParams(queryOptions),
      };

      if (queryOptions?.field && queryOptions?.value !== undefined) {
        requestPayload[queryOptions.field] = queryOptions.value;
      }

      return getVPosRoutingList(requestPayload, {
        onSuccess: (data) => {
          if (data.isSuccess) {
            function fieldValue(data) {
              return data.map((item) => {
                return {
                  "Çalışma Grubu": item?.profileCodes[0],
                  "Yönlendirelecek Kartın Bankası": item?.issuerCardBankName,
                  "Yönlendirelecek Sanal Pos": item?.merchantVposBankName,
                  "Kart Tipi": item?.issuerCardType,
                  "İşlem Tipi": item?.transactionSubType,
                  "Üye İşyeri Numarası": item?.merchantId,
                  "Üye İşyeri Adı": item?.merchantName,
                  [keyMapping["status"]]: item?.status,
                  "Oluşturma Tarihi": item?.createDate,
                  "Oluşturan Kullanıcı": item?.createUserName,
                  "Son Güncellenme Tarihi": item?.updateDate,
                  "Son Güncelleyen Kullanıcı": item?.updateUserName
                };
              });
            }
            const refactoredData = fieldValue(data?.data?.result);
            downloadExcel(
              refactoredData || [],
              "Sanal Pos Banka Listesi",
              keyMapping
            );
          } else {
            setSnackbar({
              severity: "error",
              description: data.message,
              isOpen: true,
            });
          }
        },
        onError: () => {
          setSnackbar({
            severity: "error",
            description: "İşlem sırasında bir hata oluştu",
            isOpen: true,
          });
        },
      });
    }
  };
  const hasLoading = isLoading || isDeleteLoading;

  const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func.apply(null, args);
      }, delay);
    };
  };

  const getQueryParams = (filters) => {
    const queryParams = {};

    for (let key in filters) {
      if (filters[key]?.toString()?.length >= 1) {
        if (key == 'profileCodes') {
          queryParams['profileCode'] = filters[key];
        } else {
          queryParams[key] = filters[key];
        }
      }
    }

    return queryParams;
  };

  const handleFilterChange = debounce((filters) => {
    if (filters.clearFilter) {
      localStorage.removeItem('vposBankListingFilter')
      return setQueryOptions({});
    }

    const queryParams = getQueryParams(filters);

    const isValueValid = (key, value) => {
      if (key === 'installmentCount' || key === 'issuerCardType') { // Özel alan kontrolü
        return value?.toString().length >= 1;
      } else {
        return value?.toString().length >= 3;
      }
    }


    const allValuesValid = Object.entries(queryParams).every(([key, value]) => isValueValid(key, value));

    const previousKeysLength = Object.keys(previousQueryParams.current).length;
    const currentKeysLength = Object.keys(queryParams).length;

    // Eğer queryParams bir önceki ile aynıysa işlem yapma
    if (JSON.stringify(previousQueryParams.current) === JSON.stringify(queryParams)) {
      return;
    }

    if (allValuesValid || (previousKeysLength > currentKeysLength)) {
      setQueryOptions(queryParams);
      localStorage.setItem('vposBankListingFilter', JSON.stringify(queryParams));
    }


    // Son olarak, mevcut queryParams değerini bir önceki değer olarak set edin
    previousQueryParams.current = queryParams;

  }, 500);
  const hasActiveFilters = Object?.keys(queryOptions)?.length > 0;
  // Komponent içerisinde
  const previousQueryParams = React.useRef({});



  return (
    <>
      {hasLoading && <Loading />}
      <Stack flex={1} p={2}>

        <>
          <Table
            columnVisibilityConfigKey="vposBankListingTableColumnVisibilityKey"
            filterKey="vposBankListingFilter"
            hasActiveFilters={hasActiveFilters}
            handleFilterChange={handleFilterChange}
            paginationModel={paginationModel}
            onPaginationModelChange={handleChangePagination}
            paginationMode="server"
            rowCount={tableData?.totalItems || 0}
            sx={{ width: isDesktop ? 1308 : window.innerWidth - 50 }}
            isRowSelectable={() => false}
            // disableColumnMenu
            rows={tableData?.result || []}
            columns={columns}
            exportFileName="Sanal Pos Banka Listesi"
            getRowClassName={(params) => {
              if (params?.row?.status === "PASSIVE") return "pasive-row";
              if (params?.row?.status === "BLOCKED") return "blocked-row";
              return "";
            }}
            onSave={() => onSave()}
          />
          <DeleteConfirmModal
            isOpen={isDeleteModalOpen}
            onClose={handleCloseDeleteModal}
            onConfirm={() => handleDeleteConfirm()}
          ></DeleteConfirmModal>
        </>

      </Stack>
    </>
  );
};
